export default __webpack_public_path__ + "a5401b4561796bc8dd7f525201339537.svg";